import { FILE_EXTENSIONS } from '../data'
import { HexCode, isHexCode } from '../types'

export const rgbaToHex = (rgba: string): HexCode => {
  if (isHexCode(rgba)) return rgba
  const parts = rgba.split(/[(),]/g)
  let r = Number.parseInt(parts[1]).toString(16).toUpperCase()
  let g = Number.parseInt(parts[2]).toString(16).toUpperCase()
  let b = Number.parseInt(parts[3]).toString(16).toUpperCase()
  let a = (Number.parseFloat(parts[4]) * 255).toString(16).toUpperCase()
  if (r.length === 1) r = '0' + r
  if (g.length === 1) g = '0' + g
  if (b.length === 1) b = '0' + b
  if (a.length === 1) a = '0' + a
  return `#${ r }${ g }${ b }${ a }`
}

export const removeFileExtension = (input: string): string => {
  const allExts = Object.values(FILE_EXTENSIONS).flat()
  for (const ext of allExts) {
    if (!input.includes(`.${ ext }`)) continue
    return input.split(`.${ ext }`)[0]
  }
  return input
}
